export function sortMonthDays(days) {
    return [...days].sort((a, b) => a - b);
}
export function resolveDaysOfMonthFromConfig(config) {
    if (config.daysOfMonth?.length) {
        return sortMonthDays(config.daysOfMonth);
    }
    return [config.dayOfMonth ?? 1];
}
export function resolveMonthDaysFromRule(rule) {
    if (rule.monthDays?.length) {
        return sortMonthDays(rule.monthDays);
    }
    if (rule.monthDay !== undefined && rule.monthDay !== null) {
        return [rule.monthDay];
    }
    return [1];
}
export function formatMonthDaysList(days) {
    return sortMonthDays(days).join(', ');
}
//# sourceMappingURL=month-days.js.map